import React from 'react';
import { Plus } from '@yme/assets/icons';
import { Button, FADED_VARIANT, ICON_ONLY, SIZE_44, TEXT_VARIANT, TRAILING_ICON, } from '@yme/atoms/button';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { CompareEmptyCardType } from './constants';
import { CompareEmptyCardStyled, CompareStickyBarEmptyCardStyled, CompareEmptyCardContentStyled, ButtonStyled, } from './styled';
export function CompareEmptyCard({ className, isRightToLeft = false, type = CompareEmptyCardType.DEFAULT, onClick, emptyCardRef = null, label, }) {
    const getEmptyCard = () => {
        switch (type) {
            case CompareEmptyCardType.STICKY:
                return (React.createElement(CompareStickyBarEmptyCardStyled, { height: "100%", gap: "8px", justifyContent: "center", alignItems: "center", padding: "8px", className: className },
                    React.createElement(ButtonStyled, { label: label, buttonVariant: TEXT_VARIANT, hasIconButton: TRAILING_ICON, isRightToLeft: isRightToLeft, iconComponent: Plus, onClick: onClick, "aria-label": label })));
            default:
                return (React.createElement(CompareEmptyCardStyled, { isRightToLeft: isRightToLeft, ref: emptyCardRef },
                    React.createElement(CompareEmptyCardContentStyled, { isFullWidth: true, gap: "12px", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "8px" },
                        React.createElement(Button, { isRightToLeft: isRightToLeft, buttonVariant: FADED_VARIANT, hasIconButton: ICON_ONLY, size: SIZE_44, iconComponent: Plus, onClick: onClick, "aria-label": label }),
                        React.createElement(RegularTextLevel3, { color: colorCoreBlack900Base, weight: 500 }, label))));
        }
    };
    return getEmptyCard();
}
